import React, { useMemo } from 'react'
import LineInfoCircleIcon from 'components/Luxkit/Icons/line/LineInfoCircleIcon'
import MessageBanner from 'components/Luxkit/Banners/MessageBanner'
import config from 'constants/config'
import { pluralizeToString } from 'lib/string/pluralize'

interface Props {
  totalSeatsRemaining: number;
  totalUsedSeatsOnCart: number;
  purchaseLimit: App.ExperiencePurchaseLimit;
  className?: string
}

function ExperienceTicketCustomerLimit(props: Props) {
  const { totalSeatsRemaining, totalUsedSeatsOnCart, purchaseLimit, className } = props

  const { message, kind } = useMemo(() => {
    let message = ''
    let kind: 'warning' | 'critical' = 'warning'
    if (totalSeatsRemaining <= 0) {
      kind = 'critical'
      if (purchaseLimit.maxReason === 'AVAILABILITY') message = 'You have reached the available slots for this session.'
      else if (purchaseLimit.maxReason === 'LIMIT-PER-CUSTOMER') message = `You have reached the maximum purchase limit of ${pluralizeToString('participant', purchaseLimit.max)} per account for this experience.`
      else if (purchaseLimit.maxReason === 'LIMIT-PER-ORDER') message = `You have reached the maximum purchase limit of ${pluralizeToString('participant', purchaseLimit.max)} per order for this experience.`
    } else {
      const MIN_AVAILABILITY_TO_SHOW_MESSAGE = 5
      if (purchaseLimit.min > 1 && totalUsedSeatsOnCart < purchaseLimit.min) message = `Minimum ${pluralizeToString('participant', purchaseLimit.min)} for this experience.`
      else if (purchaseLimit.maxReason === 'AVAILABILITY' && purchaseLimit.max <= MIN_AVAILABILITY_TO_SHOW_MESSAGE) message = `Only ${pluralizeToString('slot', purchaseLimit.max)} left in this session.`
      else if (purchaseLimit.maxReason === 'LIMIT-PER-CUSTOMER') message = `Maximum purchase limit of ${pluralizeToString('participant', purchaseLimit.max)} per account for this experience.`
      else if (purchaseLimit.maxReason === 'LIMIT-PER-ORDER') message = `Maximum purchase limit of ${pluralizeToString('participant', purchaseLimit.max)} per order for this experience.`
    }

    return {
      message, kind,
    }
  }, [totalSeatsRemaining, purchaseLimit, totalUsedSeatsOnCart])

  if (!message || !config.EXPERIENCES_PURCHASE_CUSTOMER_LIMIT) return null

  return (
    <MessageBanner
      className={className}
      kind={kind}
      description={message}
      icon={<LineInfoCircleIcon/>}
    />
  )
}

export default ExperienceTicketCustomerLimit
